import React from "react";
import "../styles.css";
import ImageContainer from "../components/imageContainer";
import { UserContext } from "../userContext";
const Youtube = (props) => {
  const data = React.useContext(UserContext);
  /*
      <div className="popular">
        {data.songs.items.map((val) => (
          <ImageContainer value={data.songs.items} id={val.id.videoId} />
        ))}
      </div>
      */
  if ( data.popular.items===undefined){
    return(<><div className="error"><h1>API Exhausted Please Try Later</h1></div></>)

  }   
  else{
  return (
    <section id="section1">
      <div className="popular">
          <ImageContainer value={data.popular.items} />
      </div>
      <div className="popular">
          <ImageContainer value={data.songs.items} />
      </div>
      <div className="popular">
          <ImageContainer value={data.news.items} />
      </div>
    </section>
  );
  }
};
export default Youtube;
